export const parseMoneyToNumber = (value: string): number => {
    return parseFloat(String(value).replace(/\./g, '').replace(',', '.'));
}

export const formatNumberToMoneyString = (value: number): string => {
    const negative = value < 0;
    const absoluteValue = Math.abs(value);
    const parts = absoluteValue.toFixed(2).split('.');
    const intFormatted = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return `${negative ? '-' : ''}${intFormatted},${parts[1]}`;
}